var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFrameworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.289 4.278c.95.529.95 1.717 0 2.245l-1.223.68 1.223.68c.95.527.95 1.716 0 2.244l-1.216.675 1.216.675c.95.528.95 1.717 0 2.245l-7.247 4.026c-.605.336-1.477.336-2.082 0L.713 13.722c-.95-.528-.95-1.716 0-2.245l1.216-.675-1.216-.675c-.95-.528-.95-1.717 0-2.245l1.223-.68-1.223-.68c-.95-.527-.95-1.715 0-2.244L7.96.252c.605-.336 1.477-.336 2.082 0l7.247 4.026zm-7.247 6.271l4.17-2.317 1.39.772-1.382.768-.005-.002-1.853 1.03.005.002-3.2 1.777c-.06.034-.271.034-.333 0l-3.199-1.777.005-.003-1.853-1.03-.005.003L2.4 9.004l1.39-.772 4.17 2.317c.605.336 1.477.336 2.082 0zm-6.26 1.283L2.4 12.6l6.434 3.574c.062.035.272.035.334 0l6.434-3.574-1.382-.768-4.178 2.32c-.605.337-1.477.337-2.082 0l-4.178-2.32zM8.836 1.826c.062-.034.272-.034.334 0l6.434 3.575L9.17 8.975c-.062.035-.272.035-.334 0L2.402 5.401l6.434-3.575z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFrameworks);
export default __webpack_public_path__ + "static/media/icon-frameworks.5b11ce361ae377eac5c7233a3b5d4671.svg";
export { ForwardRef as ReactComponent };